import { render, staticRenderFns } from "./PreExamsList.vue?vue&type=template&id=53c3b0ec&scoped=true"
import script from "./PreExamsList.vue?vue&type=script&lang=ts"
export * from "./PreExamsList.vue?vue&type=script&lang=ts"
import style0 from "./PreExamsList.vue?vue&type=style&index=0&id=53c3b0ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3b0ec",
  null
  
)

export default component.exports